import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["html", "css", "js", "title", "head"];
import React from 'react';
import IFrame from '@uiw/react-iframe';
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      html = '',
      css,
      js,
      title = 'Demo Title',
      head
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var jsString = js ? "<script type=\"text/javascript\">" + js + "</script>" : '';
  var cssString = css ? "<style>" + css + "</style>" : '';
  var result = "<!DOCTYPE html><html><head>" + cssString + "</head><body>" + html + "</body>" + jsString + "</html>";
  var blob = new Blob([result], {
    type: 'text/html'
  });
  var url = URL.createObjectURL(blob);
  return /*#__PURE__*/_jsx(IFrame, _extends({
    title: title,
    head: head,
    width: "100%",
    height: "100%",
    style: {
      border: 0
    }
  }, other, {
    ref: ref,
    src: url,
    mountTarget: "#mountHere"
  }));
});